import app from 'app';
import ready from 'utils/ready';
import search from './search/main';

app.add({
  'search-page': search,
});

ready(app.mount);
